import { atom } from "jotai";
import { Release } from "@quantizr-engineering/common/types/release";

export interface ReleaseState {
  loading: boolean;
  data: Release[] | null;
  lastFetched: number | null;
}

export const releasesAtom = atom<ReleaseState>({ loading: false, data: [], lastFetched: null});

export const releasesLoadingAtom = atom<boolean>(false);

export const releasesErrorAtom = atom<string | null>(null);
